import { render } from "./productPageContentSection.vue?vue&type=template&id=2f1229c3&scoped=true&ts=true"
import script from "./productPageContentSection.vue?vue&type=script&lang=ts"
export * from "./productPageContentSection.vue?vue&type=script&lang=ts"

import "./productPageContentSection.vue?vue&type=style&index=0&id=2f1229c3&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f1229c3"]])

export default __exports__